import type { IMForwarding, PinnedMessage } from '@wui/im'

/**
 * Runtime pin payload can include forwarding fields; @wui/im PinnedMessage typings
 * currently omit them from extendedParams.
 */
export type PinnedExtendedParams = PinnedMessage['extendedParams'] & IMForwarding

export const getPinnedExtendedParams = (pin: PinnedMessage): PinnedExtendedParams => {
  return pin.extendedParams as PinnedExtendedParams
}
